<template>
  <div class="basic_wrap">
    <bsHeader
      :title="data.title"
      @backurl="$router.back()"
    />
    
    <!-- ================= 正文卡片 ================= -->
    <div class="main_content">
      <div class="card_box article_card">
        <!-- 1. 顶部主标题 -->
        <div class="article_title">
          {{ data.title }}
        </div>
        
        <!-- 2. 富文本内容 -->
        <div class="contract_box" v-html="data.content" />
      </div>
    </div>
  </div>
</template>

<script>
import Fetch from "../../utils/fetch";
import bsHeader from '../../components/bsHeader.vue'

export default {
  name: "Article",
  components: {
    bsHeader
  },
  data() {
    return {
      data: {},
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#FFFFFF');
      plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/index/article_detail', {
        id: this.$router.history.current.params.code
      }).then(res => {
        this.data = res.data;
      })
    },
  }
};
</script>

<style lang="less" scoped>
/* ================= 全局基础样式 ================= */
.basic_wrap {
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 40px;
  min-height: 100vh;
  /* 浅蓝网格背景（彻底去黑） */
  background: linear-gradient(180deg, #f8fbff, #eef4fb 42%, #f6f8fc);
}

.main_content {
  padding: 16px;
}

/* ================= 白色卡片容器 ================= */
.card_box {
  background: #ffffff;
  border-radius: 18px;
  padding: 24px 20px;
  box-shadow: 0 4px 16px rgba(24, 61, 122, 0.06);
  border: 1px solid rgba(176, 202, 240, 0.3);
}

.article_card {
  /* 1. 主标题样式 */
  .article_title {
    font-size: 18px;
    font-weight: 800;
    color: #1a2742;
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: 1px solid #f1f5f9;
  }

  /* 2. 富文本内容核心样式穿透 */
  /* 注意：因为后端返回的是 v-html，必须用 :deep 才能控制内部标签 */
  :deep(.contract_box) {
    line-height: 1.8;
    margin-top: 4px;
    color: #334155;
    font-size: 15px;

    /* 大标题 (截图里的 "曼迪利投资概览") */
    h1, h2, h3, h4 {
      font-weight: 700;
      color: #1a2742; /* 深蓝黑 */
      margin: 24px 0 12px 0;
    }
    
    h2, h3 {
      font-size: 20px;
      color: #0a2540; /* 非常深的蓝色 */
    }

    /* 正文普通段落 */
    p {
      margin-bottom: 14px;
      color: #334155;
    }

    /* 截图中斜体/浅灰色的说明文字 (例如 "PT Mandiri Manajemen Investasi...") */
    em, i {
      font-style: italic;
      color: #64748b;
      font-weight: 400;
    }

    /* 截图里的加粗强调文字 */
    strong, b {
      font-weight: 700;
      color: #1a2742;
    }

    /* 列表样式 */
    ul, ol {
      padding-left: 20px;
      margin: 12px 0;
    }
    li {
      margin-bottom: 8px;
    }

    /* 如果有图片 */
    img {
      max-width: 100%;
      height: auto;
      border-radius: 12px;
      margin: 16px 0;
    }
  }
}
</style>